// src/components/ads-admin/Drawer.jsx
import React, { useState, useCallback } from "react";

const MIN_WIDTH = 340;
const DEFAULT_WIDTH = 640;

export default function Drawer({ open, title, onClose, children }) {
  const [width, setWidth] = useState(DEFAULT_WIDTH);

  const onDragStart = useCallback(
    (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startWidth = width;

      const onMove = (mv) => {
        const next = Math.max(MIN_WIDTH, Math.min(window.innerWidth * 0.92, startWidth + (startX - mv.clientX)));
        setWidth(next);
      };
      const onUp = () => {
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
      };
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    },
    [width]
  );

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.45)",
        zIndex: 120,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <div
        style={{
          width: `min(${width}px, 94vw)`,
          height: "100%",
          background: "#fff",
          borderLeft: "1px solid rgba(15,23,42,0.12)",
          boxShadow: "-20px 0 60px rgba(15,23,42,0.22)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Drag handle — left edge */}
        <div
          onMouseDown={onDragStart}
          title="Drag to resize"
          style={{
            position: "absolute",
            left: -4,
            top: 0,
            bottom: 0,
            width: 8,
            cursor: "ew-resize",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* visible grip dots */}
          <div style={{
            width: 4,
            height: 40,
            borderRadius: 4,
            background: "rgba(99,102,241,0.35)",
            transition: "background 0.15s",
          }} />
        </div>

        {/* Header */}
        <div
          style={{
            padding: 16,
            borderBottom: "1px solid rgba(15,23,42,0.10)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: 900, color: "#0f172a" }}>{title}</div>
          <button className="btn-secondary" onClick={onClose} style={{ padding: "8px 12px", borderRadius: 12 }}>
            Close
          </button>
        </div>

        <div style={{ padding: 16, overflow: "auto", flex: 1 }}>{children}</div>
      </div>
    </div>
  );
}
